<template>
  <v-chip
    filter
    small
    class="px-2 font-weight-bold"
    :class="[color, textClass]"
  >
    <slot>
      {{ count }}
    </slot>
  </v-chip>
</template>

<script>
export default {
  name: 'CountBadge',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: 'grey lighten-3',
    },
    textClass: {
      type: String,
      default: 'grey--text text--darken-1',
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-chip__content {
  justify-content: center;
  min-width: 16px !important;
}
</style>
